import DataImportPage from "components/Data/DataImportPage";
import { importPeopleFile } from "api/Community/PeopleAPI";

export const PEOPLE_FIELDS = [
  {
    category: "Personal",
    fields: [
      { field: "first_name", label: "First Name" },
      { field: "last_name", label: "Last Name" },
      { field: "given_name", label: "Given Name" },
      { field: "preferred_name", label: "Preferred Name" },
      { field: "middle_name", label: "Middle Name" },
      { field: "maiden_name", label: "Maiden Name" },
      { field: "nick_name", label: "Nick Name" }
    ]
  },

  {
    category: "Contact",
    fields: [
      { field: "email", label: "Email" },
      { field: "phone", label: "Phone" },
      { field: "emergency_contact_name", label: "Emergency Contact Name" },
      { field: "emergency_contact_phone", label: "Emergency Contact Phone" }
    ]
  },

  {
    category: "Address",
    fields: [
      { field: "street_address", label: "Street Address" },
      { field: "city", label: "City" },
      { field: "state", label: "State" },
      { field: "country", label: "Country" },
      { field: "post_code", label: "Post Code" }
    ]
  },


  {
    category: "Demographic",
    fields: [
      { field: "date_of_birth", label: "Date of Birth" },
      { field: "age", label: "Age" },
      { field: "child", label: "Child" },
      { field: "gender", label: "Gender" },
      { field: "relationship_status", label: "Relationship Status" },
      { field: "ethnicity", label: "Ethnicity" },
      { field: "nationality", label: "Nationality" },
      { field: "languages_spoken", label: "Languages Spoken" },
      { field: "employment_status", label: "Employment Status" },
      { field: "education_level", label: "Education Level" }
    ]
  },

  {
    category: "Religious",
    fields: [
      { field: "religion_self_identified", label: "Religion (Self Identified)" },
      { field: "religion_user_identified", label: "Religion (User Identified)" },
      { field: "place_of_worship", label: "Place of Worship" },
      { field: "discipleship_stage", label: "Discipleship Stage" },
      { field: "baptized", label: "Baptized" },
      { field: "baptism_date", label: "Baptism Date" },
      { field: "confirmation_date", label: "Confirmation Date" },
      { field: "first_communion_date", label: "First Communion Date" }
    ]
  },
];


const PeopleImportPage = () => (
  <DataImportPage
    title="Import People"
    modelFields={PEOPLE_FIELDS}
    importFunction={importPeopleFile}
  />
);

export default PeopleImportPage;

